module.exports = __webpack_public_path__ + "a678bfa41e28fda9563a697b5071dcc8.jpg";